import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Person from '../../endpoints/Person/Person';
import ContentGrid from '../../grids/ContentGrid';
import Sidebar from '../../components/Sidebar/Sidebar';
import fetcher from '../../utils/fetcher';
import profileQuery from '../../endpoints/Person/person.gql';
import {
  fetchMemberDriveStatus,
  addMemberDriveElements,
} from '../../utils/membershipUtils';
import { isNumeric } from '../../utils/utils';
import adCleanup from '../../utils/adCleanup';
import { parseEmbeddedAssets } from '../../utils/utils';

const ProfilePage = ({ data, pageNum, errorCode }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;

  useEffect(() => {
    fetchMemberDriveStatus().then((data) => {
      addMemberDriveElements(data);
    });
  }, []);

  return (
    <ContentGrid
      className="story-content-grid"
      sidebar={<Sidebar pageTopic={data.profile.title} />}
    >
      <div id="mainContent"></div>
      <Person data={data} pageNum={pageNum} />
    </ContentGrid>
  );
};

ProfilePage.getInitialProps = async ({
  query: { slug, previewToken },
  req,
  res,
}) => {
  let data, errorCode;
  let memberDriveData;
  const pageNum = isNumeric(slug[slug.length - 1]) ? slug.pop() : 1;
  if (req) {
    memberDriveData = res.memberDriveData;
  }

  await fetcher(profileQuery, {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
    slug: slug.join('/'),
    pageNum: parseInt(pageNum),
    previewToken: previewToken,
  })
    .then((result) => {
      data = result;
      if (data?.profile?.embeddedAssets) {
        parseEmbeddedAssets(data.profile.embeddedAssets);
      }

      if (res) {
        res.setHeader('Cache-Control', 'public, max-age=60');
      }
      if (!data.profile) {
        res.statusCode = 404;
        errorCode = res.statusCode > 200 ? res.statusCode : false;
      }
    })
    .catch((err) => {
      console.error(err);
      res.statusCode = 404;
      errorCode = res.statusCode > 200 ? res.statusCode : false;
    });

  adCleanup();
  return {
    data,
    pageNum: parseInt(pageNum),
    errorCode,
    memberDriveData,
    resourceType: data?.profile?.resourceType,
  };
};

ProfilePage.propTypes = {
  data: PropTypes.object,
  pageNum: PropTypes.number,
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default ProfilePage;
